<div [ngClass]="{'selected': isSelected, 'disabled': !isEnabled, 'greenBorder': greenBorder, 'yellowBG': yellowBG}"
     (click)="onBoutonClick()">
  <ion-icon [ngClass]="{'selected': isSelected}" src="./assets/svg/{{icone}}.svg"></ion-icon>
  <p class="typo-12-bold-green" [ngClass]="{'selected': isSelected}">{{libelle}}</p>
</div>

